import React from 'react';

const NoMatch = () => (
  <div>404</div>
);

export default NoMatch;
